import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
`;

export const ModalCard = styled.div`
  background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : '#ffffff')};
  border-radius: 8px;
  max-width: 380px;
  width: 100%;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#dcdfe4')};
`;

export const ModalTitle = styled.h3`
  font-size: 14px;
  font-weight: 300;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f3f4f6' : '#1e293b')};
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;

  svg {
    width: 16px;
    height: 16px;
    color: #1a4d4d;
  }
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 5px;
  border: none;
  background: transparent;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#f3f4f6')};
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const ModalBody = styled.div`
  padding: 12px 16px;
  overflow-y: auto;
  max-height: calc(90vh - 110px);
`;

export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 16px;
  border-top: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#dcdfe4')};
  background: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : '#f9fafb')};
`;

export const CancelButton = styled.button`
  padding: 6px 12px;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#dcdfe4')};
  background: transparent;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#374151')};

  &:hover {
    background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#f3f4f6')};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 0;
`;

export const FormLabel = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.secondary};
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 0;
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 0 12px;
  height: 38px;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#d1d5db')};
  background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : '#ffffff')};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f3f4f6' : '#1e293b')};
  font-size: 13px;
  transition: border-color 0.15s ease;

  &::placeholder {
    color: ${({ theme }) => (theme.mode === 'dark' ? '#6b7280' : '#9ca3af')};
  }

  &:focus {
    outline: none;
    border-color: #9ca3af;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SaveButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  border: none;
  background: #1a4d4d;
  color: white;

  &:hover {
    background: #143b3b;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;
